import React, { useContext, useEffect, useState } from 'react'
import { EventMetaContext } from '../SingleEvent'
import { FormControlLabel, Switch } from '@mui/material'
import API from '../../../../services/API'

const DraftEMPVisible = () => {
  const { eventMeta, setEventMeta } = useContext(EventMetaContext)
  const [isVisible, setIsVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (eventMeta?.draftEMPVisibleByClient !== undefined) {
      setIsVisible(eventMeta.draftEMPVisibleByClient)
    }
  }, [eventMeta])

  const handleChange = (e) => {
    setLoading(true)
    setEventMeta((prev) => ({
      ...prev,
      draftEMPVisibleByClient: e.target.checked, // Update the event context
    }))
    API.put('/edit-event', {
      eventID: eventMeta._id,
      draftEMPVisibleByClient: e.target.checked,
    }).then((res) => {
      if (res.status === 200) {
        setLoading(false)
      }
    })
  }

  return (
    <FormControlLabel
      label="EMP Visible to Client (including Draft)"
      color="anOrange"
      control={
        <Switch
          checked={eventMeta?.draftEMPVisibleByClient}
          onChange={handleChange}
        />
      }
    />
  )
}

export default DraftEMPVisible
